import PropTypes from "prop-types";
import React from "react";
import CustomSelect from "components/CustomSelect";
import ButtonGroup from "../ButtonGroup";

import "./_style.scss";

const ButtonSelect = ({
  buttons,
  options,
  defaultOption,
  selectedValue,
  onChange,
  isRounded,
}) => {
  const selectedValueIsWithinOptions = options !== null
    ? options
      .filter(
        ({ value }) => (value === selectedValue),
      ).length !== 0
    : null;

  return (
    <div className="button-select">
      <ButtonGroup
        className="button-select__button-group"
        buttons={buttons}
        onChange={onChange}
        value={selectedValue}
        isRounded={isRounded}
      />
      {
        options !== null
        && (
        <div className="button-select__select">
          <CustomSelect
            name="selectName"
            defaultOption={defaultOption}
            selectDefault={
              selectedValue === ""
              || !selectedValueIsWithinOptions
            }
            isSelected={selectedValueIsWithinOptions}
            onChange={onChange}
            options={options}
          />
        </div>
        )
      }
    </div>
  );
};

ButtonSelect.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
      text: PropTypes.string,
    }),
  ),
  onChange: PropTypes.func,
  isRounded: PropTypes.bool,
  defaultOption: PropTypes.string,
  selectedValue: PropTypes.string,
};

export default ButtonSelect;
